import React, { createRef, useReducer, useRef } from "react";
import PageLayout from "../PageLayout/PageLayout";
import PersonalInfo from "./PersonalInfo/PersnalInfo";
import PhotoAndVideos from "./PhotosAndVideos/Photos&Videos";
import Faq from "./Faq/Faq";
import { useSelector } from "react-redux";

export default function EditProfile() {
  const activeTab = useSelector((state) => state.commonReducer.activeTab);
  console.log({ activeTab });

  return (
    <>
      <PageLayout>
        {(activeTab == "personal-info" && <PersonalInfo />) ||
          (activeTab == "photo-and-video" && <PhotoAndVideos />) ||
          (activeTab == "faq" && <Faq />)}
      </PageLayout>
    </>
  );
}
